import { Injectable } from '@angular/core';
import * as Parse from 'parse';
import {PARSE_APP_ID, PARSE_MASTER_KEY, PARSE_SERVER_URL, production} from "../util/constants";

@Injectable()
export class BarraGovernoService {

  parseAppId = PARSE_APP_ID;
  serverURL = PARSE_SERVER_URL;
  masterKey = PARSE_MASTER_KEY;

  constructor() { }

  init() {
    if (!production) {
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-application-id': this.parseAppId});
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-master-key': this.masterKey});
    }
    Parse.initialize(this.parseAppId, this.masterKey);
    Parse.serverURL = this.serverURL;
  }

  async getBarraGoverno() {
    this.init();
    const BarraGoverno = Parse.Object.extend('barraGoverno');
    const queryBarraGoverno = new Parse.Query(BarraGoverno);
    queryBarraGoverno.include('links');
    const results = await queryBarraGoverno.find();
    const arrayFinal: Array<any> = [];
    if (results.length > 0) {
      for (let i = 0; i < results.length; i ++) {
        const queryLinks = results[i].get('links').query();
        queryLinks.ascending('ordem');
        const links = await queryLinks.find();
        const barra = JSON.parse(JSON.stringify(results[i]));
        barra.links = JSON.parse(JSON.stringify(links));
        arrayFinal.push(barra);
      }
    }
    return JSON.parse(JSON.stringify(arrayFinal))[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/barra-governo.service.ts